module.exports = __webpack_public_path__ + "static/media/electrician.8c0f6100.svg";